"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactGroupsClientImpl = void 0;
const HttpClientImpl_1 = require("./HttpClientImpl");
class ContactGroupsClientImpl extends HttpClientImpl_1.HttpClientImpl {
    constructor(options, prefix) {
        super(options);
        this.fetch = async () => {
            return this.get(`${this.prefix}/`);
        };
        this.addOrUpdateContact = async (contact) => {
            return this.put(`${this.prefix}/contact`, contact);
        };
        this.deleteContact = async (contactId) => {
            return this.delete(`${this.prefix}/contact/${contactId}`);
        };
        this.addOrUpdateGroup = async (group) => {
            return this.put(`${this.prefix}/group`, group);
        };
        this.deleteGroup = async (groupId) => {
            return this.delete(`${this.prefix}/group/${groupId}`);
        };
        this.addContactToGroup = async (contactId, groupId) => {
            return this.put(`${this.prefix}/contactgroup/${contactId}/${groupId}`);
        };
        this.addContactsToGroups = async (contactGroupIds) => {
            return this.put(`${this.prefix}/contactgroup`, contactGroupIds);
        };
        this.removeContactFromGroup = async (contactId, groupId) => {
            return this.delete(`${this.prefix}/contactgroup/${contactId}/${groupId}`);
        };
        this.removeContactsFromGroups = async (contactGroupIds) => {
            return this.put(`${this.prefix}/contactgroup/delete`, contactGroupIds);
        };
        this.prefix = `${prefix}/v1/contactgroups`;
    }
}
exports.ContactGroupsClientImpl = ContactGroupsClientImpl;
